import { inject, Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { StorageManagementService } from '../../../core/services/storage.service';
import { TpaSearchFormated } from '../models/tpa-search.model';
import { UtilsService } from '../../../shared/services/utils.service';
import { TpaSearchCoverageResExtended } from '../models/http/tpa-http.model';
import { DateOnlyPipe } from '../../../shared/pipes/date-only.pipe';
import { SobModalEmitter } from '../models/sob.model';
import { AuthService } from '../../../services/auth.service';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class TpaService {
  private componentTitle = new BehaviorSubject<string>('');
  private openSobDialog = new Subject<SobModalEmitter>();
  private openPolicyDialog = new Subject<string>();

  private dateOnly = inject(DateOnlyPipe);
  private storageManagementService = inject(StorageManagementService);
  private utilsService = inject(UtilsService);
  private authService = inject(AuthService);
  private router = inject(Router);

  private searchResults = new BehaviorSubject<TpaSearchCoverageResExtended[] | null>(null);

  currentTitle$ = this.componentTitle.asObservable();
  openSobDialog$ = this.openSobDialog.asObservable();
  openPolicyDialog$ = this.openPolicyDialog.asObservable();
  searchResults$ = this.searchResults.asObservable();

  setTitle(title: string) {
    requestAnimationFrame(() => {
      this.componentTitle.next(title);
    });
  }

  setSobOpenDialog(planId: string, showPdf: boolean) {
    this.openSobDialog.next({ planId, showPdf });
  }

  setPolicyOpenDialog(policyId: string) {
    this.openPolicyDialog.next(policyId);
  }

  setSearchResults(results: TpaSearchCoverageResExtended[] | null) {
    this.searchResults.next(results || []);
  }

  hasSearchResults(): boolean {
    const results = this.searchResults.getValue();
    return !!results;
  }

  cacheCurrentView(view: string) {
    this.storageManagementService.saveToLocalStorage('tpaCurrentView', view);
  }

  getCurrentView() {
    return this.storageManagementService.getFromLocalStorage('tpaCurrentView');
  }

  saveToLocalStorage(search: TpaSearchFormated) {
    const filteredSearches = this.getFilteredSearches(search);

    if (filteredSearches.length >= 10) {
      filteredSearches.pop();
    }
    filteredSearches.unshift(search);
    this.storageManagementService.saveToLocalStorage('tpaSearch', filteredSearches);
  }

  getFromLocalStorage() {
    return this.storageManagementService.getFromLocalStorage('tpaSearch');
  }

  formatDate(date: string): string {
    return this.dateOnly.transform(date);
  }

  tpaNavigateTo(page: 'search' | 'details') {
    const accountId = this.authService.getCurrentAccountId();
    this.router.navigate([accountId, 'tpa', page]).then();
  }

  private getFilteredSearches(search: TpaSearchFormated) {
    const searches: TpaSearchFormated[] = this.getFromLocalStorage() || [];
    const filteredSearches = searches.filter((s) => !this.utilsService.deepEqual(s, search));
    return filteredSearches;
  }
}
